import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  TRANSACTIONS,
  NOTIFICATION,
} from '../actionTypes';

const fetchTransactions = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_TRANSACTION}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_TRANSACTION}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_TRANSACTION}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_TRANSACTION}${query}${sorting}`);
};

export function* getTransactions(action) {
  try {
    const { data: { entity } } = yield call(fetchTransactions, action.payload);
    yield put({ type: TRANSACTIONS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: TRANSACTIONS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
